module.exports = __webpack_public_path__ + "static/assets/c933a7ce574d3814b59f16e5019fc327.png";